import PropTypes from 'prop-types';
import { APPLICATION_PATHS } from '../../application-core/constants';
import { withRouter } from 'react-router-dom';
import React from 'react';
import Loading from '../../core/Loading';

const baseLink = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy';

class ProjectReload extends React.Component {

  componentDidMount() {
    this.props.history.push(baseLink + this.props.location.hash);
  }

  render() {

    return (
      <div>
        <Loading offset="180px" minHeight="100%" size="large" />
      </div>
    );
  }
}

ProjectReload.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(ProjectReload);